import type { TFunction } from 'i18next';
import type { SupportedLocale } from '../i18n';
import { E164_REGEX } from '../lib/phone';

export interface BuildCourierWhatsAppLinkInput {
  readonly courierPhoneNumber: string;
  readonly courierName: string;
  readonly storeName: string;
  readonly manifestUrl: string;
  readonly locale: SupportedLocale;
  readonly t: TFunction;
}

export interface BuildCourierPortalWhatsAppLinkInput {
  readonly courierPhoneNumber: string;
  readonly courierName: string;
  readonly storeName: string;
  readonly portalUrl: string;
  readonly locale: SupportedLocale;
  readonly t: TFunction;
}

export function buildCourierWhatsAppLink(input: BuildCourierWhatsAppLinkInput): string | null {
  if (!E164_REGEX.test(input.courierPhoneNumber)) return null;
  const phone = input.courierPhoneNumber.slice(1);
  const message = input.t('admin.orders.courierAssignment.whatsappMessage', {
    courierName: input.courierName,
    storeName: input.storeName,
    manifestUrl: input.manifestUrl,
    lng: input.locale,
    interpolation: { escapeValue: false },
  });
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}

export function buildCourierPortalWhatsAppLink(
  input: BuildCourierPortalWhatsAppLinkInput,
): string | null {
  if (!E164_REGEX.test(input.courierPhoneNumber)) return null;
  const phone = input.courierPhoneNumber.slice(1);
  const message = input.t('admin.couriers.portal.whatsappMessage', {
    courierName: input.courierName,
    storeName: input.storeName,
    portalUrl: input.portalUrl,
    lng: input.locale,
    interpolation: { escapeValue: false },
  });
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
